<template>
  <div class="task-wall-manage-container">
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>许愿墙任务查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="conditions.title" placeholder="请输入任务标题" clearable />
        </el-col>
        <el-col :span="5">
          <el-select v-model="conditions.state" placeholder="任务状态" clearable style="width: 100%">
            <el-option v-for="(name, value) in stateNameMap" :key="value" :label="name" :value="value" />
          </el-select>
        </el-col>
        <el-col :span="7">
          <el-radio-group v-model="scope" @change="handleSearch">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="publish">我发布的</el-radio-button>
            <el-radio-button label="accept">我接的</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>许愿墙任务列表</span>
        <el-button type="primary" size="small" @click="handlePublish">发布任务</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="title" label="任务标题" min-width="140" show-overflow-tooltip />
        <el-table-column prop="reward" label="报酬(元)" width="90" align="center">
          <template slot-scope="scope">
            <span class="reward-text">￥{{ scope.row.reward }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="stateTagType(scope.row.state)" size="small">
              {{ getTaskStateName(scope.row.state) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="publishUserName" label="发布人" width="100" align="center" />
        <el-table-column prop="acceptUserName" label="接单人" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.acceptUserName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskTime" label="期望完成时间" width="150" align="center" />
        <el-table-column prop="address" label="地址" min-width="120" show-overflow-tooltip />
        <el-table-column prop="createTime" label="发布时间" width="160" align="center" />
        <el-table-column label="操作" align="center" width="170" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.row)">详情</el-button>
            <el-button v-if="canAccept(scope.row)" size="mini" type="success" @click="handleAccept(scope.row)">
              接单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top: 20px;" />
    </el-card>

    <add-task-wall ref="addDialog" @success="fetchData" />
    <view-task-wall ref="viewDialog" @success="fetchData" />
  </div>
</template>

<script>
import { listTaskWall, acceptTaskWall, getTaskStateName, TASK_STATE, TASK_STATE_NAME } from '@/api/community/taskWallManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId } from '@/api/user/userApi'
import AddTaskWall from '@/components/community/addTaskWall.vue'
import ViewTaskWall from '@/components/community/viewTaskWall.vue'

export default {
  name: 'TaskWallManageList',
  components: {
    AddTaskWall,
    ViewTaskWall
  },
  data() {
    return {
      loading: false,
      tableData: [],
      scope: 'all',
      stateNameMap: TASK_STATE_NAME,
      conditions: {
        title: '',
        state: '',
        communityId: ''
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.conditions.communityId = getCommunityId()
    this.fetchData()
  },
  methods: {
    getTaskStateName,
    async fetchData() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          title: this.conditions.title,
          state: this.conditions.state,
          communityId: this.conditions.communityId
        }
        // 按范围过滤：我发布的 / 我接的
        const userId = getUserId()
        if (this.scope === 'publish') {
          params.publishUserId = userId
        } else if (this.scope === 'accept') {
          params.acceptUserId = userId
        }
        const res = await listTaskWall(params)
        if (res.code !== 0) {
          this.$message.error(res.msg || '查询失败')
          this.tableData = []
          this.pagination.total = 0
          return
        }
        this.tableData = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取许愿墙任务列表失败:', error)
        this.$message.error('获取任务列表失败')
      } finally {
        this.loading = false
      }
    },
    // 待接单 且 非本人发布 才可接单
    canAccept(row) {
      return row.state === TASK_STATE.WAIT_ACCEPT && row.publishUserId !== getUserId()
    },
    stateTagType(state) {
      const map = {
        '1000': 'info',
        '2000': 'warning',
        '3000': '',
        '4000': 'warning',
        '5000': 'danger',
        '6000': 'success',
        '7000': 'info'
      }
      return map[state] || 'info'
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    handleReset() {
      this.conditions.title = ''
      this.conditions.state = ''
      this.scope = 'all'
      this.pagination.current = 1
      this.fetchData()
    },
    handlePublish() {
      this.$refs.addDialog.open()
    },
    handleDetail(row) {
      this.$refs.viewDialog.open(row.taskId)
    },
    handleAccept(row) {
      this.$confirm(`确认接单【${row.title}】？接单后请及时完成并提交凭证。`, '提示', {
        confirmButtonText: '确认接单',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await acceptTaskWall({ taskId: row.taskId })
          if (res.code === 0) {
            this.$message.success('接单成功')
            this.fetchData()
          } else {
            this.$message.error(res.msg || '接单失败')
          }
        } catch (error) {
          console.error('接单失败:', error)
          this.$message.error('接单失败')
        }
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.task-wall-manage-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .reward-text {
    color: #f56c6c;
    font-weight: bold;
  }

  .flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
    align-items: center;
  }
}
</style>
